import { render, staticRenderFns } from "./replaceLink.vue?vue&type=template&id=5ad41763&scoped=true"
import script from "./replaceLink.vue?vue&type=script&lang=js"
export * from "./replaceLink.vue?vue&type=script&lang=js"
import style0 from "./replaceLink.vue?vue&type=style&index=0&id=5ad41763&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad41763",
  null
  
)

export default component.exports